export enum TipsItemKey {
  STUDY_TECHNIQUE = 'study-techniques',
  PROBLEM_SOLVING = 'problem-solving',
  EXAM_TIPS = 'exam-tips',
}
